import React, { useState } from "react";
import { useNavigate,Link } from "react-router-dom";
import API_URLS from "../../summaryapi/apiUrls";
import LogoV from "../../assets/LogoV.png"
import { ToastContainer,toast } from "react-toastify";
const EmployeeLoginForm = () => {
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch(API_URLS.loginemployee.url, {
        method: API_URLS.loginemployee.method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          phone_number: mobile,
          password: password,
        }),
      });
  
      const data = await response.json();
  
      if (data.status === true && data.data) {
        // Store all session data first
        sessionStorage.setItem("isAuthenticated", "true");
        sessionStorage.setItem("isAdmin", "false");
        sessionStorage.setItem("employeeName", data.data.employee_name);
        sessionStorage.setItem("employeeId", data.data.employee_id);
        sessionStorage.setItem("employeePhone", data.data.phone_number);
        sessionStorage.setItem("employeeAddress", data.data.address);
        sessionStorage.setItem("employeeAdditionalInfo", data.data.additional_information);
        sessionStorage.setItem("employeeIsActive", data.data.is_active);
  
        // Show success toast
        toast.success("Login successful!", {
          position: "top-center",
          autoClose: 2000,  // Close after 2 seconds
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          onClose: () => {
            navigate("/student-enrollment");
          }
        });
  
      } else {
        setError(data.message || "Invalid credentials");
        toast.error(data.message || "Invalid credentials", {
          position: "top-center"
        });
      }
    } catch (error) {
      setError("Invalid admin credentials");
      toast.error("Invalid admin credentials", {
        position: "top-center"
      });
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-8 rounded-lg shadow-md w-full max-w-md mx-4"
      >
     <div className="flex items-center justify-center space-x-4 mb-4">
     <img src={LogoV} alt="Logo" className="h-20 w-20 object-contain" />
          <h1 className="text-3xl font-bold text-gray-800">Voluntary Login</h1>
        </div>













        {error && (
          <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md">
            {error}
          </div>
        )}

        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Mobile Number</label>
          <input
            type="text"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            placeholder="Enter mobile number"
            className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
            required
            maxLength={10}
          />
        </div>

        <div className="mb-6">
          <label className="block text-gray-700 mb-2">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
            required
          />
        </div>

        <button
          type="submit"
          className="w-full bg-blue-500 hover:bg-blue-600 text-white py-3 rounded-md transition duration-200"
        >
          Login
        </button>
        <p className="text-center mt-4 text-gray-600 text-sm">
  Developed © 2025 by{" "}
  <Link
    to="https://oakyaitservices.com/"
    target="_blank"
    rel="noopener noreferrer"
    className="text-blue-500 hover:underline"
  >
    Oakya IT Services
  </Link>
</p>
      </form>
    </div>
  );
};

export default EmployeeLoginForm;